import { useEffect, useState } from "react";

export default function useIsElectron() {
	const [isElectron, setIsElectron] = useState(true);

	useEffect(() => {
		if (navigator.userAgent.includes("electron")) {
			setIsElectron(true);
		} else {
			setIsElectron(false);
		}
	}, []);

	return isElectron;
}
